import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  styled,
  Typography,
  Container,
  IconButton,
} from "@mui/material";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentLatestConfirmed, GetDocumentLatest } from "store/api/rules";

function Rules() {
  const [rulesData, setRulesData] = useState();
  const [agree, setAgree] = useState(false);
  const [hasAgree, setHasAgree] = useState(true);
  const navigate = useNavigate();
  const notify = useNotify();
  const params = useParams();
  const Id = +params?.id;
  const isMobileView = useIsMobileView();

  const getDocumentLatest = async () => {
    try {
      const { data } = await http.get(GetDocumentLatest(Id));
      setRulesData(data.data);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  const documentLatestConfirmed = async (id) => {
    try {
      await http.post(DocumentLatestConfirmed, id);
      navigate(-1);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getDocumentLatest();
    // eslint-disable-next-line
  }, [Id]);

  useEffect(() => {
    if (rulesData?.isConfirmation) {
      setHasAgree(false);
    } else {
      setHasAgree(true);
    }
    // eslint-disable-next-line
  }, [rulesData]);

  const rules = {
    1: "قوانین مبادله",
    2: "قوانین سفارش",
    3: "قوانین برداشت",
    4: "قوانین وام",
    5: "قوانین کلی سایت",
    6: "قوانین سرمایه‌گذاری",
  }[Id];

  return (
    <Container>
      {isMobileView && (
        <Grid container spacing={2} mb={2}>
          <Grid item md={6} xs={12}>
            <IconButtonStyle
              onClick={() => {
                navigate(-1);
              }}
            >
              <ion-icon name="chevron-back-outline" />

              <Typography variant="subtitle1" color="text.main">
                {rules}
              </Typography>
            </IconButtonStyle>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2} mb={2}>
        <Grid item md={6} xs={12}>
          <Box
            display="flex"
            justifyContent={isMobileView ? "space-between" : ""}
          >
            <Box display="flex" pr={2}>
              <Typography color="text.main" variant="h6">
                {rulesData?.version}
              </Typography>

              <Typography color="text.secondary" pl={1}>
                نسخه
              </Typography>
            </Box>

            <BoxHeader pr={2}>
              <Typography color="text.main" variant="h6">
                {rulesData?.time}
              </Typography>

              <ion-icon name="time-outline" />
            </BoxHeader>

            <BoxHeader>
              <Typography color="text.main" variant="h6">
                {rulesData?.date}
              </Typography>

              <ion-icon name="today-outline" />
            </BoxHeader>
          </Box>
        </Grid>

        {!isMobileView && (
          <Grid item xs={6} textAlign="right">
            <Typography variant="h3" color="text.main" fontWeight={700}>
              {rules}
            </Typography>
          </Grid>
        )}
      </Grid>

      <Divider />

      <Grid container px={2}>
        <Grid item xs={12}>
          <Box>
            <BoxText dangerouslySetInnerHTML={{ __html: rulesData?.text }} />

            {hasAgree && (
              <Box display="flex" justifyContent="space-between" my={3}>
                <Box>
                  <FormControlLabelStyle
                    value="start"
                    control={
                      <Checkbox
                        color="success"
                        onClick={() => {
                          setAgree(!agree);
                        }}
                      />
                    }
                    label="متن را خواندم"
                    labelPlacement="start"
                  />
                </Box>

                <Box>
                  <Button
                    fullWidth
                    color="success"
                    onClick={() => {
                      documentLatestConfirmed({ id: rulesData?.id });
                    }}
                  >
                    موافقم
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
const BoxHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "ion-icon": {
    paddingLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
}));

const BoxText = styled(Box)(({ theme }) => ({
  color: theme.palette.text.main,
}));

const FormControlLabelStyle = styled(FormControlLabel)(({ theme }) => ({
  ".MuiTypography-root ": {
    color: theme.palette.text.main,
  },
}));

const IconButtonStyle = styled(IconButton)(({ theme }) => ({
  "ion-icon": {
    paddingRight: theme.spacing(1),
    color: theme.palette.text.main,
    fontSize: "14px",
  },
}));

export default Rules;
